import { render } from "./cargas.vue?vue&type=template&id=3b523168&scoped=true"
import script from "./cargas.vue?vue&type=script&lang=js"
export * from "./cargas.vue?vue&type=script&lang=js"

import "./cargas.vue?vue&type=style&index=0&id=3b523168&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src407097413/src/Abbott-Seguimiento-Email-Backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b523168"]])

export default __exports__